import type { RootState } from '@/store/main';

export const selectWatermarkSets = (state: RootState) => state.watermarks.watermarkSets;
export const selectCurrentWatermarkSet = (state: RootState) => state.watermarks.currentWatermarkSet;
export const selectWatermarksLoading = (state: RootState) => state.watermarks.loading;
export const selectWatermarksError = (state: RootState) => state.watermarks.error;
